import SvgAlertCircle from '@unifyapps/icons/solid/AlertCircle';
import SvgAlertTriangle from '@unifyapps/icons/solid/AlertTriangle';
import SvgCheckCircle from '@unifyapps/icons/solid/CheckCircle';
import SvgInfoCircle from '@unifyapps/icons/solid/InfoCircle';
import type { SnackbarProps } from './types';

export const TOAST_COLOR_TO_ICON: Record<
  NonNullable<SnackbarProps['color']>,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
  success: SvgCheckCircle,
  error: SvgAlertCircle,
  warning: SvgAlertTriangle,
  default: SvgInfoCircle,
  gray: SvgInfoCircle,
  brand: SvgInfoCircle,
};

export const VISIBLE_TOASTS_COUNT = 5;
